import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';

import {
  ChurnFlowAnalyticsBaseService,
  ChurnFlowDataBaseService,
  ChurnFlowNavigationBaseService,
  ChurnFlowReasonsService,
} from '@core/churn-flow-logic';
import { ChurnReason, ChurnReasonI } from '@core/churn-flow-types';
import {
  ChurnFlowReasonSelectableCardComponent,
  ChurnFlowStepTemplateComponent,
} from '@core/churn-flow-ui';
import { TranslatePipe } from '@core/i18n-legacy';
import { ButtonComponent, IconComponent } from '@core/user-interface-legacy';
import { injectUntilDestroyed } from '@core/utils-legacy';

import { ChurnFlowInsightsComponent } from '../../components/churn-flow-insights/churn-flow-insights.component';

@Component({
  selector: 'tlc-churn-reasons-page',
  templateUrl: './churn-reasons-page.component.html',
  styleUrls: ['./churn-reasons-page.component.less'],
  imports: [
    ChurnFlowStepTemplateComponent,
    ChurnFlowInsightsComponent,
    TranslatePipe,
    ButtonComponent,
    ChurnFlowReasonSelectableCardComponent,
    IconComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ChurnFlowReasonsService],
})
export class ChurnReasonsPageComponent {
  private readonly router = inject(Router);
  private readonly churnReasonsService = inject(ChurnFlowReasonsService);
  private readonly analytics = inject(ChurnFlowAnalyticsBaseService);
  private readonly churnFlowDataService = inject(ChurnFlowDataBaseService);
  private readonly churnFlowNavigationService = inject(ChurnFlowNavigationBaseService);
  private readonly untilDestroyed = injectUntilDestroyed();

  public readonly churnFlowReasons: ChurnReasonI[] = this.churnReasonsService.randomizedReasons();

  public selectedReason = signal<ChurnReason | null>(null);

  public selectReason(reason: ChurnReason): void {
    this.selectedReason.set(reason);
  }

  public stayWithTellent(): void {
    this.analytics.trackStayWithTellent({ step: 'step-2' });
    this.churnFlowNavigationService.stayWithTellent();
  }

  public navigateToReason(): void {
    this.analytics.trackStepTwoContinue({ reason: this.selectedReason()! });

    this.churnFlowDataService
      .lockInChurnReason(this.selectedReason()!)
      .pipe(this.untilDestroyed)
      .subscribe(reason => {
        this.churnFlowDataService.refreshSubscriptionData();
        this.router.navigate([{ outlets: { dialog: ['churn', reason] } }]);
      });
  }
}
